<script>
import NavHome from '@components/nav-bar/nav-bar-primary.vue';
import CheckoutForm from '@components/forms/checkout-form.vue';
import NavBarFooterMobile from '@components/nav-bar/nav-bar-footer-mobile.vue';
import { breakpointsMixin } from '@mixins/breakpointsMixin';
import { trainerComputed, authComputed, homeMethods, homeComputed } from '@state/helpers';
import ChatButton from '@components/chat/chat-button.vue';
import _ from 'lodash';

export default {
  components: {
    CheckoutForm,
    NavHome,
    NavBarFooterMobile,
    ChatButton,
  },
  data() {
    return {
      supportEmail: 'team@smartfitness.com',
    };
  },
  mixins: [breakpointsMixin],
  computed: {
    ...homeComputed,
    ...trainerComputed,
    ...authComputed,
    userCurrentPricePlanId() {
      return this.currentUser.user &&
        this.currentUser.user.profile &&
        _.has(this.currentUser.user.profile, 'subscribed_plan') &&
        this.currentUser.user.profile.subscribed_plan
        ? this.currentUser.user.profile.subscribed_plan
        : this.currentUser.user &&
            this.currentUser.user.invitation &&
            _.has(this.currentUser.user.invitation, 'price_plan') &&
            this.currentUser.user.invitation.price_plan;
    },
  },
  methods: {
    ...homeMethods,
    contactTrainer() {
      window.location.href = `mailto:${this.myTrainer.email}?subject=SmartFitness Access`;
    },
  },
};
</script>

<template>
  <div>
    <NavHome :transparent="true" light v-if="isDesktopView" />
    <div :class="['checkout-container', { isMobile: !$_isDesktopView(), noPlan: !userCurrentPricePlanId }]">
      <div id="divider"></div>
      <CheckoutForm v-if="userCurrentPricePlanId" />
      <div v-if="!userCurrentPricePlanId" class="page">
        <div class="container">
          <div class="header">
            <div class="title">
              <h1> Access Suspended </h1>
            </div>
            <div class="subtitle">
              <p>
                Your access to SmartFitness has been temporarily suspended. Reach out to
                <strong>{{ myTrainer.firstName }} {{ myTrainer.lastName }}</strong> for more details.
              </p>
              <br />
              <p>
                Are you receiving this notice in error?
                <a class="link-support" :href="`mailto:${supportEmail}`">Contact Support</a>
              </p>
            </div>
            <div class="buttons">
              <BaseButton class="large" @click="isDesktopView ? setViewChatList(!viewChatList) : $router.push({ name: 'chat' })">
                Contact
              </BaseButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NavBarFooterMobile v-if="!isDesktopView" />
    <ChatButton v-if="!userCurrentPricePlanId && isDesktopView" />
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.checkout-container {
  background-color: #edeef3;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: calc(100vh - 13.7rem);
  opacity: 0.98;
  padding-bottom: 40px;
  position: absolute;
  width: 100%;
  #divider {
    height: 7.6%;
    margin: 0;
    width: 100%;
  }
  &.isMobile {
    &:not(.noPlan) {
      background-color: white;
    }
  }
  .page {
    background-color: white;
    border-radius: 8px;
    color: black;
    margin: auto;
    padding-bottom: 2rem;
    padding-top: 2rem;
    position: relative;
    width: 450px;
    .circle {
      margin: auto;
      padding: 10px;
      width: 70px;
    }

    .container {
      background: #1c1c1c00;
      padding: 10px;
      width: 100%;

      .header {
        margin: 0;
        text-align: start;
        width: 100%;

        .base-progress-bar {
          margin-left: 6.4%;
          margin-top: 40px;
          width: 87.2%;
        }

        .title {
          align-self: center;
          font-family: $base-font-family;
          font-size: 18px;
          font-style: normal;
          font-weight: bold;
          margin: auto;
          margin-top: 30%;
          width: 100%;

          h1 {
            color: black;
            font-size: 36px;
            letter-spacing: -0.761905px;
            line-height: 42px;
            margin-bottom: 10px;
            margin-top: 2px;
            opacity: 0.9;
            text-align: center;
          }
        }

        .subtitle {
          align-self: center;
          font-family: $secondary-font-family;
          font-size: 16px;

          p {
            color: black;
            line-height: 23px;
            margin: 0 30px 0 30px;
            mix-blend-mode: normal;
            opacity: 0.9;
            text-align: center;
          }
        }
      }

      .buttons {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: 40px auto 20px;
        padding: 10px 10px 10px 10px;
        position: relative;
        width: 90%;
      }
      .large {
        line-height: unset;
        margin-top: 30px;
        transition-duration: 0.3s;
        width: 100%;
        @include calc-font-size(1.4);
        &:hover {
          color: white;
        }
      }
    }
  }
  &.noPlan {
    background: url('../../../assets/images/backgrounds/desktop/onboarding.jpg') center no-repeat;
    background-color: rgba(0, 0, 0, 0.15);
    background-size: cover;
    min-height: 100vh;
    &.isMobile {
      height: 100%;
      width: 100vw;
      .page {
        width: 93%;
      }
    }
  }
}
</style>
